import { useState } from 'react';

import { API_BASE_URL } from '../config/config';
import {
  ApiResponse_string,
  UnsubscribedEmailRequestDTO,
  CancelRegistrationRequestDTO,
  CommunicationClient,
} from '../services/apiClient';
import axiosInstance from '../services/axiosInstance';
import { handleHookError } from '../utils/hookUtils/handleHookError';

interface UseCommunicationApi {
  unsubscribeEmail: (
    data: UnsubscribedEmailRequestDTO,
  ) => Promise<ApiResponse_string>;
  cancelRegistration: (
    data: CancelRegistrationRequestDTO,
  ) => Promise<ApiResponse_string>;
  isLoading: boolean;
  error: string | null;
}

export const useCommunicationApi = (): UseCommunicationApi => {
  const apiClient = new CommunicationClient(API_BASE_URL, axiosInstance);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const unsubscribeEmail = async (
    data: UnsubscribedEmailRequestDTO,
  ): Promise<ApiResponse_string> => {
    setIsLoading(true);
    try {
      return await apiClient.unsubscribeEmail(data);
    } catch (err: unknown) {
      handleHookError(err, 'Error unsubscribing email', setError);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const cancelRegistration = async (
    data: CancelRegistrationRequestDTO,
  ): Promise<ApiResponse_string> => {
    setIsLoading(true);
    try {
      return await apiClient.cancelRegistration(data);
    } catch (err: unknown) {
      handleHookError(err, 'Error cancelling registration', setError);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return { unsubscribeEmail, cancelRegistration, isLoading, error };
};
